import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TEAM } from '../../../../core/constants/team';

@Component({
  selector: 'app-nuestro-equipo-media',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nuestro-equipo-media.component.html',
  styleUrls: ['./nuestro-equipo-media.component.scss']

})
export class NuestroEquipoMediaComponent implements OnInit {

  personas = TEAM;
  isMobile = false;

  constructor() {}

  ngOnInit() {
    this.checkScreenSize();
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return;
    }
    this.isMobile = window.innerWidth <= 768;
  }
}
